<template>
  <div>
    <div class="text-sm text-center m-auto uppercase my-4 tracking-wider">
      {{ $t("fixed.favoritePs") }}
    </div>
    <div
      v-if="!products.length"
      class="text-xs text-center my-4 text-slate-400 dark:text-slate-500"
    >
      {{ $t("fixed.favoritePsEm") }}
    </div>
    <div v-else class="grid-2">
      <div v-for="product in products" :key="product.id">
        <div
          class="bg-0 bg-slate-100 h-32 rounded-xl"
          @click="$router.push(`/product/${product.id}`)"
          :style="`background-image: url(${product.images[0]})`"
        ></div>
        <div class="px-4">
          <div dir="auto" class="truncate mt-2">{{ product.name }}</div>
          <div dir="auto" class="start">
            <h1 class="font-medium">{{ product.price }}</h1>
            <h6 class="text-xs mx-2">DZD</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/assets/db";

export default {
  data() {
    return {
      products: [],
    };
  },
  async created() {
    this.products = await db.products
      .where("favorite")
      .equals("true")
      .toArray();
  },
};
</script>
